/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleBenefitDistributionBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    constructor() {
        this.setDiscriminator("BillingRuleBenefitDistributionBase");
    }

    getFixupPrototypeFunction() { return BillingRuleBenefitDistributionBase.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleBenefitDistributionBase>): BillingRuleBenefitDistributionBase {
        let obj = Object.assign(new BillingRuleBenefitDistributionBase(), model);
        BillingRuleBenefitDistributionBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleBenefitDistributionBase>): BillingRuleBenefitDistributionBase {
        if (!model) return null;
        return BillingRuleBenefitDistributionBase.newInstance(<BillingRuleBenefitDistributionBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleBenefitDistributionBase) {
        if (!obj) return;

        models.BillingRuleBenefitDistributionBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleBenefitDistributionBase): boolean {
        switch (obj.__type)
        {
            case "BillingRuleBenefitDistributionBase":
                Object.setPrototypeOf(obj, BillingRuleBenefitDistributionBase.prototype);
                break;
            case "BillingRuleCommitmentShare":
                Object.setPrototypeOf(obj, models.BillingRuleCommitmentShare.prototype);
                break;
            case "BillingRuleCommitmentShareToSelf":
                Object.setPrototypeOf(obj, models.BillingRuleCommitmentShareToSelf.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof BillingRuleBenefitDistributionBase)[] {
        return [
            models.BillingRuleCommitmentShare,
            models.BillingRuleCommitmentShareToSelf,
        ];
    }

    fixupFields() {
    }

    /**
     * Name of the rule.
     */
    name: string;

    /**
     * Description of the rule.
     */
    description: string;

    /**
     * Whether the rule is active.
     */
    is_active: boolean;

}
